import "./style.css"
import {user_category} from "../users/model.js";
import {
    GETP,
    init_blur_reg,
    onloadCapatcha,
    POSTP,
    route_parse,
    toggleButtonPassw_v2,
    win_with,
    _t, logError
} from "../function.js";
import {country_alpha} from "./model.js";
import {dadata_url, dadata_token, get_mail, phone_valid, email_valid, pass_valid, capitalizeWords} from "./function.js";

const lang = $("html").attr("lang")
let dadata = false;

try {


    /**
     * форма регистрации для не зарегистрированных пользователей
     */
    function user_not() {
        try {
            let content = {
                autoheight: true,
                borderless: true,
                template: ""
            }
            let content_auth = {}
            let arrow_hidden = false;
            const auth = window.config.auth.code === 0

            if (auth) {
                if (document.body.offsetWidth <= 768) arrow_hidden = true;
                if (!arrow_hidden)
                    content = {
                        autoheight: true,
                        template: `<div class="img_arrow" style="background-image: url(/resources/images/arrow_rad.png);">`,
                        type: 'clean',
                        hidden: arrow_hidden,
                    }
                content_auth = {
                    // css: "a-hotline-card__title",
                    template: (obj) => {
                        try {
                            let res = `<h3 class="h1-text-4xl">${_t('Вы авторизованы, пользователь:')}</h3>`
                            if (obj.staff !== null)
                                res += `<span class="liner"><b>${_t('Должность')}:</b> <i>${obj.staff}</i></span>`
                            res += `<span class="liner"><b>${_t('ФИО')}:</b> <i>${obj.fio}</i></span>`
                            res += `<span class="liner"><b>${_t('Телефон')}:</b> <i>${obj.phone}</i></span>`
                            res += `<span class="liner"><b>E-mail:</b> <i>${obj.email}</i></span>`
                            if (obj.company !== null)
                                res += `<span class="liner"><b>${_t('Компания')}:</b> <i>${obj.company}</i></span>`
                            if (obj.company !== null)
                                res += `<span class="liner"><b>${_t('Адрес')}:</b> <i>${obj.address}</i></span>`
                            return res
                        } catch (e) {
                            logError(e)
                        }
                    },
                    borderless: true,
                    autoheight: true,
                    data: config.auth
                }
            } else {
                if (document.body.offsetWidth <= 768) arrow_hidden = true;
                content = {
                    css: "form_reg",
                    cols: [
                        // {
                        //     minWidth: (win_with > 375) ? 30 : 0,
                        // },
                        {
                            view: "form",
                            id: "form_reg",
                            // width: 700,
                            width: arrow_hidden ? window.innerWidth : (auth ? 500 : 590),
                            borderless: true,
                            // height: 500,
                            autoheight: true,
                            elements: [
                                {
                                    height: 20,
                                },
                                {
                                    type: "header",
                                    css: "h1-text-4xl",
                                    template: `<h1>${_t('Данные пользователя')}</h1>`,
                                    borderless: true,
                                    autoheight: true
                                },
                                {
                                    view: "text",
                                    id: "fio",
                                    name: "fio",
                                    css: "v-label-md",
                                    label: _t("Фамилия Имя Отчество"),
                                    labelPosition: "top",
                                    required: true,
                                    suggest: {
                                        css: "v-list",
                                        body: {
                                            dataFeed: function (value) {
                                                return get_fio(value);
                                            },
                                            on: {
                                                onSelectChange: function (id) {
                                                    try {
                                                        if (window.pers_data)
                                                            jqueryts.storage.local.put("fio", this.getItem(id))
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }
                                            }
                                        },
                                    },
                                    on: {
                                        onBlur: function () {
                                            try {
                                                if (dadata)
                                                    get_fio($$("fio").getValue()).then(res => {
                                                        if (res.length === 0) {
                                                            jqueryts.storage.local.remove("fio")
                                                        }
                                                    })
                                                if ($$("fio").getValue() === "")
                                                    $($$("fio").getNode()).removeClass("focus")
                                                fio_valid()
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onChange: function (id) {
                                            try {
                                                $($$("fio").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function (id) {
                                            try {
                                                $($$("fio").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        }
                                    },
                                    height: 75,
                                    invalidMessage: _t("Поле не заполнено или данные не корректны")
                                },
                                {
                                    view: "text",
                                    hidden: true,
                                    id: "staff",
                                    name: "staff",
                                    css: "v-label-md",
                                    label: _t("Должность"),
                                    labelPosition: "top",
                                    height: 75,
                                    on: {
                                        onBlur: () => {
                                            try {
                                                if ($$("staff").getValue() === "")
                                                    $($$("staff").getNode()).removeClass("focus")
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onChange: function (id) {
                                            try {
                                                $($$("staff").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function (id) {
                                            try {
                                                $($$("staff").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        }
                                    }
                                },
                                {
                                    view: "text",
                                    name: "email",
                                    id: "email",
                                    css: "v-label-md",
                                    label: "Email",
                                    labelPosition: "top",
                                    required: true,
                                    validate: jqueryts.rules.isEmail,
                                    suggest: {
                                        css: "v-list",
                                        body: {
                                            dataFeed: function (value) {
                                                return get_mail(value);
                                            },
                                            on: {
                                                onSelectChange: function (id) {
                                                    try {
                                                        if (window.pers_data)
                                                            jqueryts.storage.local.put("email", this.getItem(id))
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }

                                            }
                                        },
                                    },
                                    on: {
                                        onBlur: () => {
                                            try {
                                                if ($$("email").getValue() === "")
                                                    $($$("email").getNode()).removeClass("focus")
                                                email_valid("email")
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onChange: function (id) {
                                            try {
                                                $($$("email").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function (id) {
                                            try {
                                                $($$("email").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        }
                                    },
                                    height: 75,
                                    invalidMessage: _t("Поле не заполнено или данные не корректны")
                                },
                                {
                                    cols: [
                                        {
                                            view: "combo",
                                            name: "phone_region",
                                            id: "phone_region",
                                            css: "v-label-md",
                                            label: _t("Код страны"),
                                            labelPosition: "top",
                                            required: true,
                                            height: 75,
                                            width: 120,
                                            invalidMessage: _t("Поле обязательно для заполнения"),
                                            options: {
                                                view: "suggest",
                                                filter: function (item, value) {
                                                    try {
                                                        if (
                                                            item.mobileCode.toLowerCase().indexOf(value.toLowerCase()) !== -1
                                                            || item.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
                                                        ) {
                                                            return item
                                                        }
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                },
                                                body: {
                                                    view: "list",
                                                    css: "v-list",
                                                    id: "phone_region_list",
                                                    // data: ,
                                                    template: "#flag# #mobileCode#",
                                                    yCount: 7
                                                },
                                            },
                                            on: {
                                                onBlur: () => {
                                                    try {
                                                        if ($$("phone_region").getValue() === "")
                                                            $($$("phone_region")).removeClass("focus")
                                                        if ($$("phone").getValue() !== "")
                                                            phone_valid("phone", "phone_region")
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                },
                                                onChange: function (id) {
                                                    try {
                                                        $(this.$view).addClass("focus");
                                                        if ($$("phone").getValue() !== "")
                                                            phone_valid("phone", "phone_region")
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                },
                                                onFocus: function (id) {
                                                    try {
                                                        $(this.$view).addClass("focus");
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            view: "text",
                                            id: "phone",
                                            name: "phone",
                                            css: "v-label-md",
                                            label: _t("Телефон"),
                                            labelPosition: "top",
                                            required: true,
                                            height: 75,
                                            invalidMessage: _t("Поле обязательно для заполнения"),
                                            on: {
                                                onBlur: function () {
                                                    try {
                                                        if ($$("phone").getValue() === "")
                                                            $(this.$view).removeClass("focus")
                                                        phone_valid("phone", "phone_region")
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                },
                                                onChange: function (id) {
                                                    try {
                                                        $(this.$view).addClass("focus");
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                },
                                                onFocus: function (id) {
                                                    try {
                                                        $(this.$view).addClass("focus");
                                                    } catch (e) {
                                                        logError(e)
                                                    }

                                                }
                                            }
                                        },
                                    ]
                                },
                                {
                                    view: "text",
                                    name: "address",
                                    id: "address",
                                    css: "v-label-md",
                                    label: _t("Адрес"),
                                    labelPosition: "top",
                                    required: false,
                                    suggest: {
                                        css: "v-list",
                                        body: {
                                            dataFeed: function (value) {
                                                if (!dadata) return false;
                                                return get_address(value);
                                            },
                                            on: {
                                                onSelectChange: function (id) {
                                                    try {
                                                        if (window.pers_data)
                                                            jqueryts.storage.local.put("address", this.getItem(id))
                                                        $$("address_notification").setValues(this.getItem(id))
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }
                                            }
                                        },
                                    },
                                    on: {
                                        onBlur: function () {
                                            try {
                                                if (dadata)
                                                    get_address($$("address").getValue()).then(res => {
                                                        if (res.length === 0) {
                                                            jqueryts.storage.local.remove("address")
                                                            $$("address_notification").setValues(' ')
                                                        }
                                                    })
                                                if ($$("address").getValue() === "")
                                                    $(this.$view).removeClass("focus")
                                                address_valid()
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function (id) {
                                            try {
                                                $($$("address").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onChange: function (id) {
                                            try {
                                                $($$("address").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        }
                                    },
                                    height: 75,
                                    invalidMessage: _t("Поле обязательно для заполнения")
                                },
                                {
                                    height: 40,
                                    id: "address_notification",
                                    css: "v-hint-template",
                                    template: (obj) => {
                                        try {
                                            if (!obj.hasOwnProperty("unrestricted_value")) return '';
                                            return `<small>${obj.unrestricted_value}</small>`
                                        } catch (e) {
                                            logError(e)
                                        }

                                    },
                                    borderless: true,
                                },
                                {
                                    view: "richselect",
                                    name: "id_category",
                                    css: "v-label-md",
                                    label: _t("Тип регистрации"),
                                    labelPosition: "top",
                                    required: true,
                                    height: 75,
                                    invalidMessage: _t("Поле обязательно для заполнения"),
                                    options: {
                                        view: "suggest",
                                        body: {
                                            view: "list",
                                            css: "v-list",
                                            id: "user_category_list",
                                            template: "#name#",
                                            yCount: 7
                                        },
                                    },
                                    on: {
                                        onChange: function (id) {
                                            try {
                                                $(this.$view).addClass("focus");
                                                if (id == '2' || id == '7') {
                                                    $$("company").hide()
                                                    $$("company_notification").hide()
                                                    $$("staff").hide()
                                                } else {
                                                    $$("company").show()
                                                    $$("company_notification").show()
                                                    $$("staff").show()
                                                    init_blur_reg('.v-label-md')
                                                }
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function () {
                                            try {
                                                $(this.$view).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },

                                    }
                                },
                                {
                                    view: "text",
                                    name: "company",
                                    id: "company",
                                    css: "v-label-md",
                                    label: _t("Компания"),
                                    labelPosition: "top",
                                    hidden: true,
                                    // required: true,
                                    suggest: {
                                        css: "v-list",
                                        template: (obj) => `${obj.value}`,
                                        body: {
                                            type: {
                                                height: 72,
                                            },
                                            yCount: 7,
                                            template: (obj) => {
                                                try {
                                                    return `${obj.value}<br><span style="color: grey">${obj.data.inn}, ${obj.data.address.value}</span>`
                                                } catch (e) {
                                                    logError(e)
                                                }
                                            },
                                            dataFeed: function (value) {
                                                if (!dadata) return false;
                                                return get_company(value);
                                            },
                                            on: {
                                                onAfterSelect: function (id) {
                                                    try {
                                                        if (window.pers_data)
                                                            jqueryts.storage.local.put("company", this.getItem(id))
                                                        $$("company_notification").setValues(this.getItem(id))
                                                    } catch (e) {
                                                        logError(e)
                                                    }
                                                }
                                            }
                                        },
                                    },
                                    on: {
                                        onBlur: () => {
                                            try {
                                                if (dadata)
                                                    get_company($$("company").getValue()).then(res => {
                                                        if (res.length === 0) {
                                                            jqueryts.storage.local.remove("company")
                                                            $$("company_notification").setValues(' ')
                                                        }
                                                    })
                                                if ($$("company").getValue() === "")
                                                    $($$("company").getNode()).removeClass("focus")
                                                company_valid()
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onChange: function (id) {
                                            try {
                                                $($$("company").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onFocus: function (id) {
                                            try {
                                                $($$("company").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                    },
                                    height: 75,
                                    invalidMessage: _t("Поле обязательно для заполнения")
                                },
                                {
                                    height: (lang == 'ru') ? 140 : 20,
                                    id: "company_notification",
                                    hidden: true,
                                    css: "v-hint-template-company",
                                    template: (obj) => {
                                        try {
                                            if (!obj.hasOwnProperty("unrestricted_value")) return '';
                                            const data = obj.data;
                                            let status = '';
                                            switch (data.state.status) {
                                                case   'ACTIVE':
                                                    status = 'действующая';
                                                    break
                                                case   'LIQUIDATING':
                                                    status = 'ликвидируется';
                                                    break
                                                case   'LIQUIDATED':
                                                    status = 'ликвидирована';
                                                    break
                                                case   'BANKRUPT':
                                                    status = 'банкротство';
                                                    break
                                                case   'REORGANIZING':
                                                    status = 'в процессе присоединения к другому юрлицу, с последующей ликвидацией';
                                                    break
                                            }
                                            let type = ''
                                            switch (data.type) {
                                                case   'LEGAL':
                                                    type = 'юридическое лицо';
                                                    break
                                                case   'INDIVIDUAL':
                                                    type = 'индивидуальный предприниматель';
                                                    break
                                            }
                                            let post = ''
                                            if (data.management !== null) {
                                                post = `${data.management.post}: ${data.management.name}<br>`
                                            }
                                            return `<small>
                                        Адрес организации: ${data.address.unrestricted_value}<br>
                                        ${post}
                                        Статус: ${status} Тип организации: ${type}<br>
                                        ИНН:${data.inn} КПП:${data.kpp}  ОГРН: ${data.ogrn} ОКАТО:${data.okato}
                                        </small>
                                        `
                                        } catch (e) {
                                            logError(e)
                                        }
                                    },
                                    borderless: true,
                                },
                                {
                                    type: "header",
                                    css: "h1-text-4xl",
                                    template: `<h1>${_t('Пароль')}</h1> <span id="passw-reg-con"></span>`,
                                    borderless: true,
                                    autoheight: true
                                },
                                {
                                    view: "text",
                                    id: "passw-reg",
                                    name: "passw-reg",
                                    css: "v-label-md",
                                    label: _t("Пароль"),
                                    labelPosition: "top",
                                    required: true,
                                    height: 75,
                                    type: "password",
                                    invalidMessage: _t("Поле обязательно для заполнения"),
                                    on: {
                                        onChange: function (id) {
                                            try {
                                                $($$("passw-reg").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onBlur: () => {
                                            try {
                                                if ($$("passw-reg").getValue() === "")
                                                    $($$("passw-reg").getNode()).removeClass("focus")
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },

                                        onFocus: function (id) {
                                            try {
                                                $($$("passw-reg").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                    }

                                },
                                {
                                    view: "text",
                                    id: "passw-re",
                                    name: "passw-re",
                                    css: "v-label-md",
                                    label: _t("Подтверждение пароля"),
                                    labelPosition: "top",
                                    required: true,
                                    height: 75,
                                    type: "password",
                                    invalidMessage: _t("Поле обязательно для заполнения"),
                                    on: {
                                        onChange: function (id) {
                                            try {
                                                $($$("passw-re").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                        onBlur: () => {
                                            try {
                                                if ($$("passw-re").getValue() === "")
                                                    $($$("passw-re").getNode()).removeClass("focus")
                                                pass_valid("passw-reg", "passw-re")
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },

                                        onFocus: function (id) {
                                            try {
                                                $($$("passw-re").getNode()).addClass("focus");
                                            } catch (e) {
                                                logError(e)
                                            }
                                        },
                                    }

                                },
                                {
                                    css: "reg_gray",
                                    template: _t(`Пароль должен содержать минимум 6 символов. Должны присутствовать буквы и цифры.`),
                                    borderless: true,
                                    autoheight: true
                                },
                                {
                                    height: 40
                                },
                                {
                                    cols: [
                                        {
                                            view: "checkbox",
                                            css: "v-check",
                                            width: 30,
                                            id: "allow_pers",
                                            name: "allow_pers",
                                            labelWidth: 0,
                                            align: "left",
                                            on: {
                                                onChange:()=>{
                                                    updateAllow()
                                                }
                                            }

                                        },
                                        {
                                            width: 1,
                                        },
                                        {
                                            template: `
<div style="color: black" class="label_check_reg">
${_t('Политика обработки персональных данных')}
</div>
`,
                                            borderless: true,
                                            autoheight: true
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "checkbox",
                                            css: "v-check",
                                            width: 30,
                                            id: "allow_pers_2",
                                            name: "allow_pers_2",
                                            labelWidth: 0,
                                            align: "left",
                                            on: {
                                                onChange:()=>{
                                                    updateAllow()
                                                }
                                            }
                                        },
                                        {
                                            width: 1,
                                        },
                                        {
                                            template: `
<div style="color: black" class="label_check_reg">
${_t('Политика обработки персональных данных_2')}
</div>
`,
                                            borderless: true,
                                            autoheight: true
                                        }
                                    ]
                                },
                                {
                                    id: 'captcha-container-reg',
                                    autoheight: true,
                                    width: 320,
                                    borderless: true,
                                    css: "smart-captcha-parent",
                                    template: `<div id="captcha-container-reg" class="smart-captcha"></div>`
                                },
                                {
                                    template: `#err#`,
                                    data: {err: "..."},
                                    height: 55,
                                    css: 'err_reg_hide',
                                    id: 'err_reg',
                                    borderless: true
                                },
                                {
                                    view: "button",
                                    css: "v-btn-ts-md",
                                    id: "reg_btn",
                                    disabled: true,
                                    value: _t("Зарегистрироваться"),
                                    width: 180,
                                    height: 45,
                                    click: () => {
                                        reg_auth()
                                    }
                                },
                                {
                                    height: 30
                                },

                            ],
                            on: {
                                onChange: function (newv, oldv, config) {
                                    try {
                                        if (window.pers_data)
                                            jqueryts.storage.local.put("form_reg", $$("form_reg").getValues());
                                        err(0)
                                    } catch (e) {
                                        logError(e)
                                    }
                                }
                            },
                            rules: {
                                email: jqueryts.rules.isEmail,
                            }
                        },
                        {
                            minWidth: 50,
                        }
                    ]
                }

                content_auth = {
                    rows: [
                        {
                            height: 40,
                            hidden: !arrow_hidden
                        },
                        {
                            // hidden: auth,
                            css: "reg_title_3",
                            // template: "777",
                            template: `${_t(`Уже есть учетная запись?`)}`,
                            borderless: true,
                            height: 40,
                        },
                        {
                            height: 40
                        },
                        {

                            cols: [
                                {
                                    width: 10
                                },
                                {
                                    view: "button",
                                    css: "v-btn-ts-md",
                                    value: _t("Авторизоваться"),
                                    width: 140,
                                    height: 45,
                                    click: () => {
                                        $$("win_auth").show()
                                    }
                                },
                                {}


                            ]
                        },
                        {
                            height: 40
                        },
                    ]

                }
            }
            $("#reg_form").css("min-height", "200px!important")
            $(".block-main").css("min-height", "200px!important")
            // alert(arrow_hidden)
            const ui = {
                container: document.getElementById("reg_form"),
                align: "center",
                width: arrow_hidden ? window.innerWidth : 1200,
                id: "user_not",
                body: {
                    cols: [
                        {
                            width: arrow_hidden ? window.innerWidth : (auth ? 500 : 590),
                            rows: [
                                {
                                    height: 20
                                },
                                {
                                    css: "h1-text-4xl",
                                    template: `<h1>${_t('Регистрация')}</h1>`,
                                    borderless: true,
                                    autoheight: true
                                },
                                {
                                    height: 20
                                },
                                content,
                            ]
                        },
                        {
                            width: 40,
                            hidden: arrow_hidden,
                        },
                        {
                            rows: [
                                {
                                    hidden: arrow_hidden,
                                    height: 90
                                },
                                {
                                    type: "space",
                                    width: arrow_hidden ? window.innerWidth : 450,
                                    // height: 300,
                                    // autoheight: true,
                                    padding: arrow_hidden ? 0 : 30,
                                    borderless: false,
                                    css: "reg_isset",
                                    rows: [
                                        content_auth
                                    ]
                                },
                                {}
                            ]
                        },
                    ],
                },
            }
            if (arrow_hidden) {
                ui.body.rows = jqueryts.copy(ui.body.cols)
                delete ui.body.cols
            }
            jqueryts.ui(ui)

            if (auth) {
                // $$("user_not").height(700)
                // $("#reg_form").height(700)
                $("#reg_form").css("min-height", "400px")
                return true
            }

            // toggleButtonPassw("passw-reg", "v-icon-reg", true)
            // toggleButtonPassw("passw-re", "v-icon-re", true)
            toggleButtonPassw_v2("passw-reg")
            toggleButtonPassw_v2("passw-re")
            init_label_check_reg()

            jqueryts.promise.all([
                user_category.waitData,
                country_alpha.waitData,
            ]).then(function (resolve) {
                try {
                    $$("phone_region_list").sync(country_alpha)
                    $$("user_category_list").sync(user_category)

                    if ($$("form_reg"))
                        jqueryts.extend($$("form_reg"), jqueryts.ProgressBar);
                    const data = jqueryts.storage.local.get("form_reg");
                    if (data) {
                        delete data.allow_pers
                        delete data.allow_pers_2
                        $$("form_reg").setValues(data)
                    }
                    if (jqueryts.storage.local.get("address")) {
                        $$("address_notification").setValues(jqueryts.storage.local.get("address"))
                    }
                    if (jqueryts.storage.local.get("company") && lang === 'ru') {
                        $$("company_notification").setValues(jqueryts.storage.local.get("company"))
                    }
                    if ($$("phone").getValue() != "")
                        phone_valid($$("phone").getValue())
                    if ($$("phone_region").getValue() === "") {
                        const phone_region = country_alpha.find(el => el.code === "RU")
                        $$("phone_region").setValue(phone_region[0].id)
                    }
                } catch (e) {
                    logError(e)
                }
            })
            window.addEventListener('resize', function () {
                reg_resize()
            })
            setTimeout(() => {
                try {
                    onloadCapatcha('captcha-container-reg')
                } catch (e) {
                    logError(e)
                }
            }, 1000)
        } catch (e) {
            logError(e)
        }

    }

    /**
     * Респонзив формы регистрации
     */
    function reg_resize() {
        try {
            if (window.innerWidth < 700) {
                $$("form_reg").define("minWidth", window.innerWidth - 100)
            }
            $$("user_not").resize()
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Лабел для чекбокса подтверждения обработки персональных данных
     */
    function init_label_check_reg() {
        try {
            $(".label_check_reg").click(function () {
                try {
                    if ($$("allow_pers").getValue() == 0) {
                        $$("allow_pers").setValue(1)
                    } else {
                        $$("allow_pers").setValue(0)
                    }
                } catch (e) {
                    logError(e)
                }
            })
        } catch (e) {
            logError(e)
        }
    }


    /**
     * Подсказки фамилиии DaData
     * @param query
     * @param parts
     * @returns {boolean}
     */
    function get_fio(query, parts = ["SURNAME", "NAME", "PATRONYMIC"]) {
        try {
            if (!dadata) return false;
            const url = `${dadata_url}/fio`;
            const options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + dadata_token
                },
                body: JSON.stringify({query: query, parts: parts})
            }
            return fetch(url, options)
                .then(response => response.json())
                .then(result => result.suggestions)
                .catch(error => console.log("error", error));
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Подсказки адреса DaData
     * @param query
     * @returns {Promise<any>}
     */
    function get_address(query) {
        try {
            const url = `${dadata_url}/address`;

            const options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + dadata_token
                },
                body: JSON.stringify({query: query})
            }
            return fetch(url, options)
                .then(response => response.json())
                .then(result => result.suggestions)
                .catch(error => console.log("error", error));
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Подсказки компании DaData
     * @param query
     * @returns {Promise<any>}
     */
    function get_company(query) {
        try {

            const url = `${dadata_url}/party`;
            const options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + dadata_token
                },
                body: JSON.stringify({query: query})
            }
            return fetch(url, options)
                .then(response => response.json())
                .then(result => result.suggestions)
                .catch(error => console.log("error", error));
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Валидация фамилии с использованием DaData
     * @returns {boolean}
     */
    function fio_valid() {
        try {

            let fio = $$("fio").getValue()
            $$("fio").setValue(capitalizeWords(fio))
            $($$("fio").getNode()).removeClass("jqueryts_invalid")
            if ($($$("fio").getNode()).find(".jqueryts_inp_bottom_label").length == 0) {
                $($$("fio").getNode()).append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`)
            }
            $($$("fio").getNode()).find(".jqueryts_inp_bottom_label").text("")

            if (!dadata) {
                fio = fio.replaceAll(/\d/g, ' ')
                fio = fio.trim(" ")
                fio = fio.replace(/\s{2,}/g, ' ')
                const parts = fio.split(' ')

                if (parts.length < 2) {
                    $($$("fio").getNode()).addClass("jqueryts_invalid")
                    $($$("fio").getNode()).find(".jqueryts_inp_bottom_label").text(_t("Проверьте корректность заполнения фамилии, имени и отчества"))
                    return false
                }
                return true
            }
            return get_fio(fio).then(res => {
                try {
                    if (res.length === 1) {
                        jqueryts.storage.local.put("fio", res)
                    }
                    if (res.length === 0) {
                        $($$("fio").getNode()).addClass("jqueryts_invalid")
                        $($$("fio").getNode()).find(".jqueryts_inp_bottom_label").text(_t("Проверьте корректность заполнения фамилии, имени и отчества"))
                        return false
                    }
                    fio = fio.trim(" ")
                    fio = fio.replace(/\s{2,}/g, ' ')
                    const parts = fio.split(' ')

                    if (parts.length < 2) {
                        $($$("fio").getNode()).addClass("jqueryts_invalid")
                        $($$("fio").getNode()).find(".jqueryts_inp_bottom_label").text(_t("Проверьте корректность заполнения фамилии, имени и отчества"))
                        return false
                    }
                    return true
                } catch (e) {
                    logError(e)
                }
            })
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Валидация адреса с использованием DaData
     * @returns {Promise<*>}
     */
    function address_valid() {
        try {

            $($$("address").getNode()).removeClass("jqueryts_invalid")
            if ($($$("address").getNode()).find(".jqueryts_inp_bottom_label").length == 0) {
                $($$("address").getNode()).append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`)
            }
            $($$("address").getNode()).find(".jqueryts_inp_bottom_label").text("")
            const address = $$("address").getValue()
            if (address === "") return true
            if (!dadata) return true
            return get_address(address).then(res => {
                try {
                    if (res.length === 1) {
                        jqueryts.storage.local.put("address", res)
                    }
                    if (!$$("address").validate()) return false;
                    if (res.length === 0) {
                        $($$("address").getNode()).addClass("jqueryts_invalid")
                        $($$("address").getNode()).find(".jqueryts_inp_bottom_label").text("Проверьте корректность заполнения адреса")
                        return false
                    }
                    return true
                } catch (e) {
                    logError(e)
                }
            })
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Валидации компании с использованием DaData
     * @returns {Promise<*>}
     */
    function company_valid() {
        try {

            $($$("company").getNode()).removeClass("jqueryts_invalid")
            if ($($$("company").getNode()).find(".jqueryts_inp_bottom_label").length == 0) {
                $($$("company").getNode()).append(`<div class="jqueryts_inp_bottom_label" role="alert" aria-relevant="all"></div>`)
            }
            $($$("company").getNode()).find(".jqueryts_inp_bottom_label").text("")
            const company = $$("company").getValue()

            if (company === "") return true
            if (!dadata) return true
            return get_company(company).then(res => {
                try {
                    if (res.length === 1) {
                        jqueryts.storage.local.put("company", res)
                    }
                    if (!$$("company").validate()) return false;
                    if (res.length === 0) {
                        $($$("company").getNode()).addClass("jqueryts_invalid")
                        $($$("company").getNode()).find(".jqueryts_inp_bottom_label").text("Проверьте корректность заполнения наименования компании")
                        return false
                    }
                    return true
                } catch (e) {
                    logError(e)
                }
            })
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Сообщение об ошибке при регистрации
     * @param code
     * @param text
     */
    function err(code, text = "") {
        try {
            $($$("err_reg").getNode()).removeClass("err_reg")
            $($$("err_reg").getNode()).addClass("err_reg_hide")
            if (code !== 0) {
                $($$("err_reg").getNode()).addClass("err_reg")
                $($$("err_reg").getNode()).removeClass("err_reg_hide")
                $$("err_reg").setValues({err: text})
            }
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Проверка согласия на обработку перс данных
     * @returns {boolean}
     */
    function allow_pers_valid() {
        try {
            err(0)
            if ($$("allow_pers").getValue() !== 1) {
                err(1, _t("Вы не дали согласие на обработку персональных данных"))
                return false
            }
            return true
        } catch (e) {
            logError(e)
        }
    }

    /**
     * Отправка данных регистрации на сервер
     * @returns {boolean}
     */
    function reg_auth() {
        try {
            err(0)
            if (!$$("form_reg").validate()) {
                err(1, _t("Поля формы заполнены не корректно"))
                return false
            }
            const data = $$("form_reg").getValues()
            if (!allow_pers_valid()) return false;
            if (!phone_valid("phone", "phone_region")) {
                err(1, _t("Телефон заполнен не корректно"))
                return false
            }
            if (!pass_valid("passw-reg", "passw-re")) {
                err(1, _t("Пароль указан не корректно"))
                return false
            }
            data.phone = phone_valid("phone", "phone_region")
            jqueryts.promise.all([
                fio_valid(),
                email_valid("email")
            ]).then(function (resolve) {
                try {

                    if (!resolve[0]) {
                        err(1, _t("Поле ФИО заполнено не корректно"))
                        return false
                    }
                    if (!resolve[1]) {
                        err(1, _t("Поле Email заполнено не корректно"))
                        return false
                    }

                    data.json_company = {}
                    if (jqueryts.storage.local.get("company"))
                        data.json_company = jqueryts.storage.local.get("company")

                    data.json_fio = {}
                    if (jqueryts.storage.local.get("fio"))
                        data.json_fio = jqueryts.storage.local.get("fio")

                    data.json_address = {}
                    if (jqueryts.storage.local.get("address"))
                        data.json_address = jqueryts.storage.local.get("address")

                    data.pers_data = {}
                    if (jqueryts.storage.local.get("pers_data"))
                        data.pers_data = jqueryts.storage.local.get("pers_data")

                    data.smart_token = $('#captcha-container-reg>input[name="smart-token"]').val();
                    data.lang = lang
                    $$("form_reg").showProgress()
                    POSTP("auth/reg", data).then(res => {
                        try {
                            $$("form_reg").hideProgress()
                            if (res.code === 0) {
                                $$("reg_success").show()
                                $$("form_reg_success").show()
                                const mess = _t(`Сообщение успешной регистрации`)
                                    .replace('{{fio}}', data.fio)
                                    .replace('{{email}}', data.email)
                                    .replace('{{lang}}', lang)
                                $$("form_reg_success").setValues({
                                    message: `<div style="line-height: 22px">${mess}</div>`
                                })
                            } else {
                                err(1, res.message)
                                onloadCapatcha('captcha-container-reg')
                                return false
                            }
                        } catch (e) {
                            $$("form_reg").hideProgress()
                            logError(e)
                        }
                    })
                } catch (e) {
                    $$("form_reg").hideProgress()
                    logError(e)
                }
            })
        } catch (e) {
            $$("form_reg").hideProgress()
            logError(e)
        }
    }
    function updateAllow(){
        const allow_pers   = $$("allow_pers").getValue()
        const allow_pers_2 = $$("allow_pers_2").getValue()
        console.log(allow_pers, allow_pers_2)
        if (allow_pers == 1 && allow_pers_2 == 1){
            $$("reg_btn").enable()
        } else {
            $$("reg_btn").disable()
        }
    }

    jqueryts.ui({
        view: "window",
        id: "reg_success",
        css: "win_auth bg",
        width: win_with,
        height: 240,
        move: false,
        modal: true,
        position: "center",
        head: {
            padding: 20,
            view: "toolbar",
            elements: [
                {
                    view: "label",
                    label: _t("Подтверждение электронной почты"),
                    css: "v-header"
                },
                {
                    view: "icon", icon: "wxi-close", click: function () {
                        $$("reg_success").close();
                    }
                }
            ]
        },
        body: {
            rows: [
                {
                    template: `<div style="padding: 10px">#message#</div>`,
                    data: {
                        message: "..."
                    },
                    id: 'form_reg_success',
                    css: "login_success",
                    borderless: true,
                    hidden: true,
                },
                {
                    template: `<div style="padding: 10px">#message#</div>`,
                    data: {message: "..."},
                    css: 'err_reg',
                    id: 'form_reg_err',
                    hidden: true,
                    borderless: true
                }
            ],
        },
    }).hide()

    /**
     * Разбор роутинга
     * @type {string[]}
     */
    const route = route_parse();


    /***
     * Форма регистрации
     */
    if (route[3] === "reg") {
        GETP("dadata/stat").then(res => {
            try {
                dadata = res.status
                user_not()
            } catch (e) {
                logError(e)
            }
        })
    }


} catch (e) {
    logError(e)
}
